/* eslint-disable no-unused-vars */
import { Form, message } from 'antd';
import { useDispatch } from 'dva';
import { useState, useCallback } from 'react';
import ButtonML from '@/components/button_ml/ButtonML';
import InputML from '@/components/input_all_ml/add_input_ml/AddInputML';
import { isNumber } from '@/utils/validation';
import Loading from '@/components/Loading';
import styles from './addMember.less?modules';

const AddMember = (props) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  // 发起请求
  const onFinish = (values) => {
    setLoading(true);
    dispatch({
      type: 'ruleginDGM/addDiagram',
      payload: {
        values: {
          ...values,
        },
      },
      callback: (data) => {
        setLoading(false);
        if (data.id) {
          message.success('新增成功');
          props.handleOk(data);
        } else {
          message.error('决策图名称或编号重复');
        }
      },
    });
  };

  const handleCancel = () => {
    props.handleCancel();
  };

  return (
    <Loading loading={loading}>
      <Form
        form={form}
        name="control-hooks"
        onFinish={onFinish}
        className={styles.serarchFrom}
      >
        <div className={styles.input_contain}>
          {/* 流程名称 */}
          {/* <AddSelectML
            labelVal="决策图名称"
            placeVal="请选择决策图名称"
            name="name"
            option={props.options}
            allowClear={true}
          /> */}
          <InputML
            labelVal="决策图名称"
            placeVal="请输入决策图名称"
            name="name"
            required={[
              {
                required: true,
                whitespace: true,
                message: '请输入决策图名称',
              },
            ]}
          />

          {/* 流程编号 */}
          <InputML
            labelVal="决策图编号"
            placeVal="请输入决策图编号"
            name="code"
            required={[
              {
                required: true,
                whitespace: true,
                message: '请输入决策图编号',
              },
              ({ getFieldValue }) => ({
                validator(rule, value) {
                  if (!value || isNumber(value)) {
                    return Promise.resolve();
                  }
                  return Promise.reject('决策图编号格式为数字');
                },
              }),
            ]}
          />

          {/* 描述 */}
          <InputML
            labelVal="描述"
            placeVal="请输入描述"
            name="description"
            required={[
              {
                required: true,
                whitespace: true,
                message: '请填写描述',
              },
            ]}
          />

          {/* 起始节点 */}
          <InputML
            labelVal="起始节点"
            placeVal="请输入起始节点"
            name="startNode"
            required={[
              {
                required: true,
                whitespace: true,
                message: '请填写起始节点',
              },
            ]}
          />

          {/* 终止节点 */}
          <InputML
            labelVal="结束节点"
            placeVal="请输入结束节点"
            name="endNode"
            required={[
              {
                required: true,
                whitespace: true,
                message: '请填写结束节点',
              },
            ]}
          />
        </div>
        <footer className={styles.footer}>
          <ButtonML
            size="large"
            value="取消"
            htmlType="submit"
            fontsize="16px"
            onClick={handleCancel}
          />
          <ButtonML
            size="large"
            value="保存"
            htmlType="submit"
            fontsize="16px"
          />
        </footer>
      </Form>
    </Loading>
  );
};

export default AddMember;
